<div class="row p-2 mb-3 align-items-center">
  <div class="col-12 col-md-7 text-start">
    <div class="page-title-heading">
      <div class="page-title-icon"><i class="fa-solid fa-envelope-open-text"></i></div>
      <div>
        Demande de permission
        <div class="page-title-subheading">Gestion des demandes de permission</div>
      </div>
    </div>
  </div>
  <div class="col-12 col-md-5 text-end">
    <app-header></app-header>
  </div>
</div>
   <div class="row">
    <div class="col-lg-12">
        <div class="card">
          
            <div class="card-body">
                  <div class="d-flex justify-content-between mb-5">
                    <div class="me-2">
                        <button *ngIf="buttonsPermission?.add" type="button" class="btn btn-danger btn-sm" (click)="add(addContent)">
                            <i class="fa-solid fa-plus me-2" aria-hidden="true"></i>Nouvelle demande
                            </button>
                    </div>
                    <div class=" " *ngIf="buttonsPermission">
                        <button *ngIf="selected_data && buttonsPermission.show"  (click)="show(showContent)" type="button" class="btn btn-outline-primary btn-sm btn-label waves-effect waves-light me-3">
                             <span>Consulter</span></button>
                        <button *ngIf="buttonsPermission.edit && role!='dg' && selected_data?.status==0" (click)="edit(editContent)" type="button"  class="btn btn-outline-warning btn-sm btn-label waves-effect waves-light me-3">
                           Editer</button>
                        <button *ngIf="buttonsPermission.delete && role!='dg' && selected_data?.status==0" (click)="delete()" type="button" class="btn btn-outline-danger btn-sm btn-label waves-effect waves-light me-3">
                             Supprimer</button>
                             <button *ngIf="role=='dg' && is_active ==0" (click)="setStatus(1)" type="button" class="btn btn-outline-success btn-sm btn-label waves-effect waves-light me-3">
                                Accepter</button>
                               <button  *ngIf="role=='dg' && is_active ==0" (click)="add(rejectContent)" type="button" class="btn btn-outline-danger btn-sm btn-label waves-effect waves-light me-3">
                                Rejeter</button>
                    </div>

                    <div class="form-group ms-auto">
                        <label for=""> <strong>Rechercher:</strong> </label>
                        <input placeholder="Rechercher..." class="form-control form-control-sm" type="text" name="search_text" [(ngModel)]="search_text">
                    </div>
                </div>

                        <p>{{data!.length}} élément(s)</p>
                        <div class="table-responsive">
                        <table class="table" >
                            <thead class="">
                                <tr>
                                    <th style="width: 10px;">#</th>
                                    <th>Date enreg.</th>
                                    <th>Objet</th>
                                    <th>Demandeur</th>
                                    <th>Statut</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr (click)="checked(d)" [class.table-active]="selected_data?.id === d.id" style="cursor: pointer;" *ngFor="let d of data | sampleSearch:search_text:'rooms' | paginate: {
                                id:'ngxP1',
                                itemsPerPage: pg.pageSize,
                                currentPage: pg.p,
                                totalItems: pg.total } ">
                                    <td>
                                        <div class="form-check mb-2">
                                            <input (click)="checked(d)" class="form-check-input" type="radio" [checked]="selected_data?.id === d.id" name="flexRadioDefault">
                                        
                                        </div>
                                    </td>
                                    <td>{{d.created_at | date:"dd-MM-yyyy"}}</td>
                                    <td>{{d.object}}</td>
                                  
                                </tr>
                            
                            </tbody>
                        </table>
                        </div>
                        <pagination-controls 
                        id="ngxP1"
                        (pageChange)="getPage($event)"
                      [maxSize]="9"
                      [directionLinks]="true"
                      [autoHide]="true"
                      [responsive]="true"
                      [previousLabel]="'Précédent'"
                      [nextLabel]="'Suivant'"
                      [screenReaderPaginationLabel]="'Pagination'"
                      [screenReaderPageLabel]="'page'"
                      [screenReaderCurrentLabel]="'Vous êtes sur la page'">
                     </pagination-controls>

            </div><!-- end card -->
        </div>
        <!-- end col -->
    </div>
    <!-- end col -->
</div>


<ng-template #addContent let-c="close" let-d="dismiss">
    <form #addForm="ngForm" (ngSubmit)="store(addForm.value)">
    <div class="modal-header">
      <h6 class="modal-title" id="modal-basic-title">Enregistrer une demande de permission</h6>
      <button type="button" class="btn-close" aria-label="Close" (click)="d('Cross click')"></button>
    </div>
    <div class="modal-body" >
        <div class="row mb-3" >
      
            <div class=" form-group col-12 mb-3">
                <label for="">Objet <span class="text-danger ml-2">(*)</span></label>
                <input type="text" name="object" class="form-control" ngModel required>
            </div>
            <div class=" form-group col-12 mb-3">
                <label for="">Description <span class="text-danger ml-2">(*)</span></label>
                <textarea name="description" ngModel class="form-control"></textarea>
            </div>
            <div class="form-group ">
                <label for="">Période</label>
                <ng-select name="period_id" ngModel>
                    <ng-option selected disabled></ng-option>
                    <ng-option *ngFor="let p of periods" [value]="p.id">{{p.name}}</ng-option>
                </ng-select>
            </div>
            <div class="form-group ">
                <label for="">Choisir la catégorie de personnel</label>
                <ng-select (change)="loadConcerned($event)" >
                    <ng-option selected disabled></ng-option>
                    <ng-option *ngFor="let rp of request_permissions" [value]="rp">{{rp}}</ng-option>
                </ng-select>
            </div>
            <div class="form-group ">
                <label for="">Choisir le concerné</label>
                <ng-select name="concerned_id" ngModel  >
                    <ng-option selected disabled></ng-option>
                    <ng-option *ngFor="let c of concerned" [value]="c.id">{{c.lastname}} {{c.firstname}}</ng-option>
                </ng-select>
            </div>
         
        </div>
       
    </div>
    <div class="modal-footer">
      <button type="submit" class="btn btn-outline-dark" [disabled]="addForm.invalid"  >Enregistrer <app-loading [isVisible]="loading"></app-loading></button>
    </div>
</form>
  </ng-template>

  <ng-template #editContent let-c="close" let-d="dismiss">
    <form #editForm="ngForm" (ngSubmit)="update(editForm.value)">
    <div class="modal-header">
      <h6 class="modal-title" id="modal-basic-title">Modifier une demande de permission</h6>
      <button type="button" class="btn-close" aria-label="Close" (click)="d('Cross click')"></button>
    </div>
    <div class="modal-body" >
        <div class="row mb-3" >
      
            <div class=" form-group col-12 mb-3">
                <label for="">Objet <span class="text-danger ml-2">(*)</span></label>
                <input type="text" name="object" class="form-control" [(ngModel)]="selected_data.object" required>
            </div>
            <div class=" form-group col-12 mb-3">
                <label for="">Description <span class="text-danger ml-2">(*)</span></label>
                <textarea name="description" [(ngModel)]="selected_data.description" class="form-control"></textarea>
            </div>
            <div class="form-group ">
                <label for="">Période</label>
                <ng-select name="period_id" [(ngModel)]="selected_data.period_id">
                    <ng-option selected disabled></ng-option>
                    <ng-option *ngFor="let p of periods" [value]="p.id">{{p.name}}</ng-option>
                </ng-select>
            </div>
            <div class="form-group ">
                <label for="">Choisir la catégorie de personnel</label>
                <ng-select name="type" [(ngModel)]="type" (change)="loadConcerned($event)" >
                    <ng-option selected disabled></ng-option>
                    <ng-option *ngFor="let rp of request_permissions" [value]="rp">{{rp}}</ng-option>
                </ng-select>
            </div>
            <div class="form-group ">
                <label for="">Choisir le concerné</label>
                <ng-select name="concerned_id" [(ngModel)]="selected_data.concerned_id"  >
                    <ng-option selected disabled></ng-option>
                    <ng-option *ngFor="let c of concerned" [value]="c.id">{{c.lastname}} {{c.firstname}}</ng-option>
                </ng-select>
            </div>
         
        </div>
       
       
    </div>
    <div class="modal-footer">
      <button type="submit" class="btn btn-outline-dark" [disabled]="editForm.invalid" >Sauvegarder <app-loading [isVisible]="loading"></app-loading></button>
    </div>
</form>
  </ng-template>

  <ng-template #showContent let-c="close" let-d="dismiss">
    <div class="modal-header">
        <h4 class="modal-title" id="modal-basic-title">Détails des informations</h4>
        <button type="button" class="btn-close" aria-label="Close" (click)="d('Cross click')"></button>
      </div>

      <div class="modal-body">
        <div class="table-responsive table-card">
            <dl>
                <dt>Objet</dt>
                <dd>{{selected_data.object}}</dd>
            </dl>
            <dl>
                <dt>Détails</dt>
                <dd>{{selected_data.description}}</dd>

            </dl>
            <dl>
                <dt>Auteur</dt>
                <dd>
                    <span *ngIf="selected_data.type =='Enseignant'">{{selected_data.professor?.lastname}} {{selected_data.professor?.firstname}}</span>
                    <span *ngIf="selected_data.type =='Apprenant'">{{selected_data.student?.lastname}} {{selected_data.student?.firstname}}</span>
                    <span *ngIf="selected_data.type =='Personnel'">{{selected_data.personal?.lastname}} {{selected_data.personal?.firstname}}</span>
                </dd>

            </dl>
            <dl *ngIf="selected_data.motif">
                <dt>Motif</dt>
                <dd>{{selected_data.motif}}</dd>

            </dl>
        </div>
      </div>
</ng-template>
  <ng-template #rejectContent let-c="close" let-d="dismiss">
    <form #editForm="ngForm" (ngSubmit)="reject(editForm.value)">

    <div class="modal-header">
        <h4 class="modal-title" id="modal-basic-title">Motif du rejet</h4>
        <button type="button" class="btn-close" aria-label="Close" (click)="d('Cross click')"></button>
      </div>

      <div class="modal-body">
        <div class="form-group">
            <label for="">Motif du rejet</label>
            <textarea name="motif" class="form-control" ngModel></textarea>
        </div>
      </div>
      <div class="modal-footer">
        <button type="submit" class="btn btn-outline-dark" [disabled]="editForm.invalid" >Sauvegarder <app-loading [isVisible]="loading"></app-loading></button>
      </div>
    </form>

</ng-template>
